import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { UiPictureModule } from '@big-direkt/ui/picture';
import { UiTagComponent } from '@big-direkt/ui/tag';
import { IconBigMediumPfeilRechts, IconComponent } from '@big-direkt/utils/icons';
import { type PageTitleModel } from '@big-direkt/utils/shared';

@Component({
    selector: 'big-ui-page-title',
    templateUrl: './page-title.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'block print:hidden relative',
    },
    imports: [IconComponent, NgClass, UiLinkComponent, UiPictureModule, UiTagComponent],
})
export class PageTitleComponent {
    public readonly iconArrowRight = IconBigMediumPfeilRechts;

    public readonly model = input<PageTitleModel | null>();
    public readonly headingSize = input<'h1' | 'h2' | 'h3'>('h2');
}
